export const splitCardholderName = (fullName: string): { firstName: string; lastName: string } => {
	const trimmed = fullName.trim();
	if (!trimmed) {
		return { firstName: '', lastName: '' };
	}

	const parts = trimmed.split(/\s+/);
	if (parts.length === 1) {
		return { firstName: parts[0], lastName: parts[0] };
	}

	return {
		firstName: parts[0],
		lastName: parts.slice(1).join(' '),
	};
};
